<template>
  <dialogComp title="分配权限" :isShow="isShow" @close="close" @sure="sure" :loading="loading">
    <el-tree
      :data="limitMenuData"
      show-checkbox
      node-key="id"
      ref="tree"
      highlight-current
      :default-checked-keys="checkKeyList"
      :filter-node-method="filterNode"
      :props="defaultProps"
    >
      <!-- check-strictly 父子不依赖-->
    </el-tree>
  </dialogComp>
</template>
<script>
import { permissionByRole, savePermissionByRole } from '@/api'
export default {
  name: '',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  data () {
    return {
      loading: false,
      limitMenuData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      checkKeyList: []
    }
  },
  computed: {},
  watch: {
    isShow (val) {
      val && this.getList()
    }
  },
  created () {},
  mounted () {},
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    async getList () {
      const res = await permissionByRole({ roleId: this.info.id })
      if (res.code === '1') {
        this.limitMenuData = res.data
        this.recursive(res.data)
        // this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.checkKeyList) // 获取已经设置的资源后渲染
        // })
      }
    },
    recursive (data) {
      data.forEach((item, index) => {
        /* if (item.checked) {
          this.checkKeyList.push(item.id)
        }
        if (item.children && item.children.length > 0) {
          this.recursive(item.children)
        } */
        if (item.children && item.children.length > 0) {
          this.recursive(item.children)
        } else {
          if (item.checked) {
            this.checkKeyList.push(item.id)
          }
        }
      })
    },
    close () {
      this.limitMenuData = []
      this.checkKeyList = []
      this.$emit('close')
    },
    sure () {
      const params = {
        list: this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys()),
        roleId: this.info.id
      }
      this.loading = true
      savePermissionByRole(params).then(res => {
        this.loading = false
        if (res.code === '1') {
          this.$message.success('分配成功')
          this.close()
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
